import { InAppPublicOnlyContextType } from 'marketplace-ui-common/types';
import { createContext, useContext } from 'react';

const AppContext = createContext<InAppPublicOnlyContextType>('app');

export const AppContextProvider = AppContext.Provider;

export function useAppContext() {
  return useContext(AppContext);
}
